import React from 'react';
import Layout from '../../../layout/Layout';
import arrowIcon from '../../../assets/arrowNext.png';
import HeaderPageSection from '../../../components/molecules/HeaderPageSection/HeaderPageSection';
import Breadcrumb from '../../../components/atoms/Breadcrumb/Breadcrumb';
import EditRuleForm from '../organisms/EditRuleForm';
import { useParams } from 'react-router-dom';

export default function EditRule() {
  const { id } = useParams();

  return (
    <Layout>
      <HeaderPageSection />

      <Breadcrumb
        title={'Editar regla'}
        separator={<img src={arrowIcon} alt="arrowIcon" />}
        items={[{ label: 'Reglas', path: '/rules' }, { label: 'Editar Regla', path: '#' }]} />

      <div className="m-auto mt-6">
        <EditRuleForm ruleId={Number(id)} />
      </div>
    </Layout>

  );
}

